import { ThemeConfig } from 'antd';

export const themeConfig: ThemeConfig = {
  token: {
    colorPrimary: '#2563eb',
    borderRadius: 6,
    colorBgLayout: '#f8fafc',
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    colorTextHeading: '#1e293b',
    colorText: '#334155',
  },
  components: {
    Layout: {
      siderBg: '#0f172a',
      headerBg: '#ffffff',
      bodyBg: '#f8fafc',
    },
    Menu: {
      darkItemBg: '#0f172a',
      darkItemSelectedBg: '#2563eb',
      darkItemColor: '#94a3b8',
      darkItemSelectedColor: '#ffffff',
      darkSubMenuItemBg: '#020617',
      itemHeight: 40,
      itemMarginInline: 8,
      itemBorderRadius: 6,
    },
    Card: {
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
      headerFontSize: 16,
      headerFontWeight: 600,
      colorBorderSecondary: '#e2e8f0',
    },
    Table: {
      headerBg: '#f1f5f9',
      headerColor: '#475569',
      headerBorderRadius: 6,
      rowHoverBg: '#f8fafc',
      borderColor: '#e2e8f0',
    },
    Button: {
      controlHeight: 36,
      fontWeight: 500,
      defaultShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    },
    Input: {
      controlHeight: 36,
      colorBorder: '#cbd5e1',
      hoverBorderColor: '#2563eb',
      activeShadow: '0 0 0 2px rgba(37, 99, 235, 0.1)',
    },
    Select: {
      controlHeight: 36,
    }
  },
};
